export default "__VITE_ASSET__08672179__"